import BaseService from './BaseService'

class ApiService extends BaseService {
  /**
   * @returns {*}
   * @returns {PromiseLike<HttpResponse>}
   */
  getInfo () {
    return this.execute('block/info')
  }

  /**
   * @returns {*}
   * @returns {PromiseLike<HttpResponse>}
   */
  getBlocks () {
    return this.execute('block/list', { params: { offset: 0, limit: 6 } })
  }

  /**
   * @returns {*}
   * @returns {PromiseLike<HttpResponse>}
   */
  getTransactions () {
    return this.execute('tx/last')
  }

  /**
   * @returns {*}
   * @returns {PromiseLike<HttpResponse>}
   */
  getAddress (address, from, limit) {
    let query_args = `?limit=${limit || 10}`
    if (from) {
      query_args += `&from=${from}`
    }
    return this.execute(`address/info/${address}${query_args}`)
      .then(response => {
        return response
      })
  }

  /**
   * @param {string} id
   * @returns {PromiseLike<HttpResponse>}
   */
  searchById (id) {
    return this.execute(`search/${id}`)
      .then(response => {
        if (!response) {
          return null
        }

        return response
      })
  }

  /**
   * @returns {*}
   * @returns {PromiseLike<HttpResponse>}
   */
  getRawTx (id) {
    return this.execute(`tx/raw/${id}`)
  }
}

export default new ApiService()



// WEBPACK FOOTER //
// ./src/service/ApiService.js